import React, { useState } from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { ListEntry } from './ListEntry';
import { ListPlaceholder } from './ListPlaceholder';
import { ListTimeline } from './ListTimeline';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TvGuideList = ({
  time: timeInput,
  date,
  programs,
  activeChannelId,
  placeholderChannelCount,
  isLoading,
  onSelectProgram,
  stickyTopPosition
}) => {
  const [time, setTime] = useState(timeInput);
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsx(ListTimeline, {
      time: timeInput,
      date: date,
      onChange: setTime,
      stickyTopPosition: stickyTopPosition
    }), /*#__PURE__*/_jsx(ListContent, {
      children: programs?.map(programGuide => /*#__PURE__*/_jsx(ListEntry, {
        programGuide: programGuide,
        onSelectProgram: onSelectProgram,
        date: date,
        time: time,
        activeChannelId: activeChannelId
      }, programGuide.channel.urn))
    }), /*#__PURE__*/_jsx(ListPlaceholder, {
      isLoading: isLoading,
      placeholderChannelCount: placeholderChannelCount
    })]
  });
};
const Layout = styled.div.withConfig({
  displayName: "TvGuideList__Layout",
  componentId: "sc-1a37msh-0"
})(["background-color:", ";"], Colors.GREY_1a1a1a);
export const ListContent = styled.div.withConfig({
  displayName: "TvGuideList__ListContent",
  componentId: "sc-1a37msh-1"
})(["display:grid;grid-auto-flow:row;grid-gap:4px;"]);